// components/BackButton.jsx
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

const BackButton = () => {
  const navigate = useNavigate();
  return (
    <button
      onClick={() => navigate(-1)}
      className="flex items-center text-sm text-purple-300 hover:text-purple-100 mb-4"
    >
      <ArrowLeft className="mr-1 w-4 h-4" /> Back
    </button>
  );
};

export default BackButton;
